import { render, staticRenderFns } from "./PostDocCp.vue?vue&type=template&id=b8fdf26c&scoped=true&"
import script from "./PostDocCp.vue?vue&type=script&lang=js&"
export * from "./PostDocCp.vue?vue&type=script&lang=js&"
import style0 from "./PostDocCp.vue?vue&type=style&index=0&id=b8fdf26c&prod&lang=css&"
import style1 from "./PostDocCp.vue?vue&type=style&index=1&id=b8fdf26c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fdf26c",
  null
  
)

export default component.exports